import { dismissToast, useToast } from '../lib/toast.ts';

/**
 * The bottom-of-screen explanation for why the board has stopped moving.
 *
 * Sits above the home indicator and below nothing, because it is the only
 * thing on screen that is allowed to cover the times. `role="status"` rather
 * than `alert`: it is worth announcing, but it must not interrupt whatever a
 * screen reader was in the middle of saying.
 */
export function Toast() {
  const toast = useToast();
  if (!toast) return null;

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 bottom-0 z-40 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]"
    >
      <div className="bg-raised border-line pointer-events-auto mx-auto flex max-w-lg items-start gap-2.5 rounded-xl border p-3 shadow-lg">
        <svg
          viewBox="0 0 24 24"
          className="text-late mt-0.5 size-4 shrink-0"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
          <path d="M12 9v4" />
          <path d="M12 17h.01" />
        </svg>
        <span className="text-ink flex-1 text-[13px]">{toast.message}</span>
        <button
          type="button"
          onClick={dismissToast}
          aria-label="Stäng"
          className="text-faint focus-visible:outline-accent -my-1 -mr-1 min-h-8 rounded-lg px-2 text-[15px] focus-visible:outline-2"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
